import {
    FETCH_EWGROUPS_BEGIN,
    FETCH_EWGROUPS_SUCCESS,
    FETCH_EWGROUPS_FAILURE,
    SET_EWGROUP_SELECT,
    FILTER_EWGROUP,
    SET_EWGROUP_NULL,
    CLEAR_GROUPS
  } from "../action/ewGroupActions";
  
  const initialState = {
    groups: [],
    filteredGroups : [],
    loading: false,
    error: null,
  };
  
  export default function ewLoadReducer(
    state = initialState,
    action
  ) {
    switch (action.type) {

      case CLEAR_GROUPS:
      let s = {...state}
      let ks = Object.keys(s)
      let selKeys = ks.filter((k) => {return k.includes('selected')})

      selKeys.forEach(k => {
        delete s[k]
      });

      return s

      case FILTER_EWGROUP:

      var fGroups = state.groups.filter(g=>{
          if(action.payload.roles){
            var filter = action.payload.roles.filter(role=>{
              return g.name == role.name
            })
            return filter.length > 0
          } 
          return false
        
      })

      let ns = {...state}
      ns['groupCo' + action.payload.index] = fGroups

      return ns
      

      case FETCH_EWGROUPS_BEGIN:
        // Mark the state as "loading" so we can show a spinner or something
        // Also, reset any errors. We're starting fresh.
        return {
          ...state,
          loading: true,
          error: null
        };
  
      case FETCH_EWGROUPS_SUCCESS:
        // All done: set loading "false".
        // Also, replace the groups with the ones from the server
        
        return {
          ...state,
          loading: false,
          groups: action.payload.ewGroups.data
        };
  
      case FETCH_EWGROUPS_FAILURE:
        // The request failed, but it did stop, so set loading to "false".
        // Save the error, and we can display it somewhere
        // Since it failed, we don't have groups to display anymore, so set it empty.
        // This is up to you and your app though: maybe you want to keep the groups
        // around! Do whatever seems right.
        return {
          ...state,
          loading: false,
          error: action.payload.error,
          groups: []
        };

        case SET_EWGROUP_SELECT:

        let newState = {...state}

        if(action.payload.group == null){
          console.log('removing the group')
           newState['selected' + action.payload.index] = {}
        }
        else
        newState['selected' + action.payload.index] = action.payload.group

     //   console.log('selecting ' + newState['selected' + action.payload.index])

        return newState

        case SET_EWGROUP_NULL:
        
        return{
            ...state
        }
  
      default:
        // ALWAYS have a default case in a reducer
        return state;
    }
  }
  